import { Agent } from './agent';
import { Group } from './group';
import { StatementRef } from './statement_ref';
import { ContextActivities } from './context_activity';
export class Context {
    registration;
    instructor;
    team;
    contextActivities;
    revision;
    platform;
    language;
    statement;
    extensions;
    constructor(cfg = {}) {
        const { registration, revision, platform, language, extensions } = cfg;
        this.instructor = this.agent_group(cfg.instructor);
        this.team = this.agent_group(cfg.team);
        this.registration = registration;
        this.revision = revision;
        this.platform = platform;
        this.language = language;
        this.extensions = extensions;
        if (cfg.contextActivities) {
            if (cfg.contextActivities instanceof ContextActivities) {
                this.contextActivities = cfg.contextActivities;
            }
            else {
                this.contextActivities = new ContextActivities(cfg.contextActivities);
            }
        }
        if (cfg.statement) {
            if (cfg.statement instanceof StatementRef) {
                this.statement = cfg.statement;
            }
            else if (cfg.statement.objectType === 'StatementRef') {
                this.statement = new StatementRef(cfg.statement);
            }
        }
    }
    agent_group(value) {
        if (value === undefined) {
            return undefined;
        }
        if (value.objectType === undefined || value.objectType === 'Person') {
            value.objectType = 'Agent';
        }
        if (value.objectType === 'Agent') {
            if (value instanceof Agent) {
                return value;
            }
            else {
                return new Agent(value);
            }
        }
        else if (value.objectType === 'Group') {
            if (value instanceof Group) {
                return value;
            }
            else {
                return new Group(value);
            }
        }
    }
    asVersion(version = '1.0.3') {
        const result = {};
        result.registration = this.registration;
        result.revision = this.revision;
        result.platform = this.platform;
        result.language = this.language;
        result.extensions = this.extensions;
        result.instructor = this.instructor && this.instructor.asVersion(version);
        result.team = this.team && this.team.asVersion(version);
        result.statement = this.statement && this.statement.asVersion(version);
        return result;
    }
    static fromJSON(contextJSON) {
        const _context = JSON.parse(contextJSON);
        return new Context(_context);
    }
}
